const { ClientHttp } = require("./client-http");

const AxiosAdapter = function (baseUrl) {
  this.httpClient = new ClientHttp(baseUrl);
};

AxiosAdapter.prototype.get = function (url, payload) {
  return new Promise((resolve, reject) => {
    this.httpClient.request.get(url)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  })
}

AxiosAdapter.prototype.post = function (url, payload= '') {
  return this.httpClient.request.post(url, payload);
}

AxiosAdapter.prototype.patch = function (url, payload= '') {
  return this.httpClient.request.patch(url, payload);
}

AxiosAdapter.prototype.remove = function (url) {
  return this.httpClient.request.delete(url)
}

AxiosAdapter.prototype.changeBaseUrl = function (url) {
  return this.httpClient.request.changeBaseUrl(url);
}

AxiosAdapter.prototype.getUrlBase = function () {
  return this.httpClient.getUrlBase();
}

AxiosAdapter.prototype.setAuthHeader = function (token) {
  this.httpClient.setAuthHeader(token);
}

module.exports = {
  AxiosAdapter
}